import { Directive, Input, TemplateRef, inject } from '@angular/core';
import { BoschUiTableService } from '../bosch-ui-table.service';

@Directive({
  selector: '[boschUiHeaderRowDef]',
  standalone: false,
})
export class BoschUiHeaderRowDefDirective<DataType> {
  public readonly templateRef = inject(TemplateRef<DataType>);
  private readonly tableService = inject(BoschUiTableService<DataType>);

  @Input() set boschUiHeaderRowDef(columns: string[]) {
    this.tableService.createHeaderRowCells(columns);

    this._rowDisplayColumns = columns;
  }

  get headerRowDisplayColumns(): string[] {
    return this._rowDisplayColumns;
  }

  private _rowDisplayColumns: string[] = [];
}
